import { IAppCardConfig } from '@orcha/micro-library-core-ui';
import { injectable } from 'inversify';
import ApiClient from './api-client';
import { IAppCardService } from './interfaces';

@injectable()
class AppCardService implements IAppCardService {
  private appCardClient: ApiClient;

  public constructor() {
    this.appCardClient = new ApiClient(process.env.APP_CARD_API_BASE_URL ?? '');
  }

  public async getAppCardConfig(
    tenantId: string,
    packageId: string,
    appCardConfigId: string
  ): Promise<IAppCardConfig | undefined> {
    const response = await this.appCardClient.get<IAppCardConfigDataWrapper>(
      `/v1/tenants/${tenantId}/packages/${packageId}/app-card-configurations/${appCardConfigId}`
    );
    return response.data?.appCard;
  }
}

interface IAppCardConfigDataWrapper {
  data?: { appCard?: IAppCardConfig };
  success: boolean;
}

export default AppCardService;
